var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg118Music(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 511.999 511.999"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M489.883,13.483C475.828,2.039,457.585-2.418,439.781,1.269L205.839,50.41C178.119,56.149,158,80.859,158,109.165v224.379 c-16.488-12.276-36.911-19.548-59-19.548c-54.589,0-99,44.411-99,99s44.411,99,99,99c54.387,0,98.671-44.083,98.998-98.394 c0.002-0.09,0.002-0.181,0.002-0.272V188.261l274-58.276v139.56c-16.488-12.276-36.911-19.548-59-19.548 c-54.589,0-99,44.411-99,99s44.411,99,99,99c10.706,0,21.245-1.704,31.325-5.064c10.479-3.494,16.142-14.82,12.648-25.299 c-3.493-10.479-14.82-16.141-25.299-12.648c-5.993,1.998-12.276,3.011-18.675,3.011c-32.532,0-59-26.467-59-59 c0-32.533,26.468-59,59-59c32.532,0,59,26.467,59,59v0.133c0,11.046,8.954,20,20,20c11.046,0,20-8.954,20-20V60.011 C512,41.886,503.938,24.927,489.883,13.483z M99,471.997c-32.532,0-59-26.467-59-59c0-32.533,26.468-59,59-59s59,26.467,59,59 C158,445.53,131.532,471.997,99,471.997z M472,89.09l-274,58.276v-38.201c0-9.436,6.707-17.672,16.004-19.597l233.942-49.142 c1.359-0.281,2.726-0.42,4.083-0.42c4.552,0,8.989,1.557,12.599,4.495c4.685,3.815,7.372,9.468,7.372,15.51V89.09z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg118Music);
export default __webpack_public_path__ + "static/media/118-music.1bae0b45e9c8d8609072421a0e743291.svg";
export { ForwardRef as ReactComponent };